const cardMixins = {
  data() {
    return {
      cardMixins: [],
      containerTop: 0
    };
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let list = this.changeScrollTop(scrollTop);
      if (list.length > 0) {
        this.$refs.Card.changeType(true);
      } else {
        this.$refs.Card.changeType(false);
      }
    },
    changeScrollTop(scrollTop) {
      return this.cardMixins.filter(item => {
        return (
          scrollTop >= item.offsetTop - this.containerTop / 0.75 &&
          scrollTop <=
            item.clientHeight * 0.5 + item.offsetTop - this.containerTop / 2 &&
          item.type
        );
      });
    },
    removeScroll() {
      window.removeEventListener("scroll", this.handleScroll, true);
    }
  },
  created() {},
  mounted() {
    this.containerTop = document.querySelector("#container").offsetTop;
    for (let i = 0; i < this.$data.LeiMonList.length; i++) {
      let mainObj = {};
      mainObj["offsetTop"] = document.querySelector(`#images${i}`).offsetTop;
      mainObj["clientHeight"] = document.querySelector(
        `#images${i}`
      ).clientHeight;
      mainObj["type"] = this.$data.LeiMonList[i].changeType;
      this.cardMixins.push(mainObj);
    }
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  destroyed() {
    this.removeScroll();
  }
};
export default cardMixins;
